import { useGetCurrentUser } from 'gcs-common/clients/api/entities/current-user/current-user-api';
import { CHAT_ROUTES } from 'gcs-common/constants/routes';
import { Navigate } from 'react-router';
import Landing from '../LoginLanding/Landing';

function LandingRoot() {
  const { isSuccess } = useGetCurrentUser();

  if (isSuccess) {
    return <Navigate to={CHAT_ROUTES.CHAT} replace />;
  }

  return <Landing />;
}

export default LandingRoot;
